import React from 'react';
import {Route, Redirect} from 'react-router-dom'


const PrivateRoute = ({ component, redirectTo, ...props }) => {
    
    const renderMergedProps = (component, ...props) => {
        const finalProps = Object.assign({}, ...props);
        return (
            React.createElement(component, finalProps)
        );
    };

    return (
        <Route {...props} render={routeProps => {
            return props.auth ? (
                renderMergedProps(component, routeProps, props)
            ) : (
                <Redirect to={{
                    pathname: redirectTo,
                    state: { from: routeProps.location }
                }}/>
            );
        }}/>
    );
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/route/PrivateRoute.js